import Image from "next/image";
import { IconDownload } from "@tabler/icons-react";
import { cn } from "@/lib/utils";
import type { FooterStoreLinkItem } from "./footerItems";
import { Typography } from "@/components/Typography";

type FooterStoreButtonsProps = {
  items: FooterStoreLinkItem[];
  variant?: "mobile" | "desktop";
  showDownloadIcon?: boolean;
};

export const FooterStoreButtons = ({
  items,
  variant = "desktop",
  showDownloadIcon = false,
}: FooterStoreButtonsProps) => {
  const isMobile = variant === "mobile";

  return (
    <div className="flex flex-col gap-2">
      {items.map((item) => {
        const displayLabel = isMobile ? `Get it on ${item.label}` : item.label;

        return (
          <a
            key={item.href}
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={displayLabel}
            className={cn(
              "flex h-12 items-center justify-center rounded-full border bg-white px-6 transition hover:bg-subtle focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-offset-1",
              isMobile ? "w-full gap-3" : "min-w-[170px] gap-2",
              showDownloadIcon && "justify-between",
            )}
          >
            <Image
              src={item.icon}
              alt=""
              width={item.iconWidth}
              height={item.iconHeight}
              aria-hidden="true"
            />
            <Typography variant="button-sm" className="flex items-center">
              {displayLabel}
            </Typography>
            {showDownloadIcon ? <IconDownload stroke={1.6} /> : null}
          </a>
        );
      })}
    </div>
  );
};
